<template>
    <v-container grid-list-xl>
        <v-layout wrap justify-space-between v-if="mode == 'finish'">
            <v-flex xs12 md12>
                <h1>비번찾기</h1>
                <h1>Reset Password</h1>

                <v-alert :value="true" type="info">
                    {{ message }}
                </v-alert>

                <v-btn :to="`/profile/login`">로그인 / Login</v-btn>
            </v-flex>
        </v-layout>

        <v-layout wrap justify-space-between v-if="mode == 'start'">
            <v-flex xs12 md12>
                <h1>비번찾기</h1>
                <h1>Reset Password</h1>
            </v-flex>

            <v-flex xs12 md12>
                <v-form @submit.prevent="confirm" ref="form">
                    <v-text-field
                        v-model="new_password"
                        :rules="[rules.reasonable_length]"
                        :error-messages="new_password_error_messages"
                        label="New Password"
                        type="password"
                    ></v-text-field>
                </v-form>
            </v-flex>
            <br />
            주의: 당신이 설정하는 패스워드는 수십만원을 지불한 당신의 티켓을
            보호합니다. 용도에 적합한 패스워드를 설정하세요.
            <br />
            Remember: Your password protects tickets worth hundreds of dollars.
            Pick a decent one.
            <v-flex xs12 md12 text-xs-right>
                <v-btn @click="confirm">Forgot Password</v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { fetcher } from "@/fetcher.js";
export default {
    props: ["auth"],
    data: () => ({
        mode: "start",
        message: "",
        phone: "+82",
        new_password: "",
        new_password_error_messages: [],
        rules: {
            required: (value) => !!value || "Required.",
            reasonable_length: (value) =>
                (value.length >= 8 && value.length < 32) ||
                "Between 8 and 32 characters",
        },
    }),
    methods: {
        confirm: async function({ router }) {
            if (!this.$refs.form.validate()) {
                return;
            }
            var res = await fetcher.post("/myprofile/reset_password", {
                code: this.$route.params.code,
                new_password: this.new_password,
            });
            console.log("verify result", res);

            if (!res.data.success) {
                this.new_password_error_messages = res.data.message;
            } else {
                this.mode = "finish";
                this.message = res.data.message;
                let cancelHandle = this.$scrollTo("#appbody"); // scroll to top of page
                return;
            }
        },
    },
};
</script>
